import React, { useState } from "react";
import PropTypes from "prop-types";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { FormattedMessage } from "react-intl";

import testIds from "constants/testIds";
import { ReactComponent as CopyIcon } from "assets/images/icons/CopyToClipboard.svg";
import DuplicateDialog from "./DuplicateDialog";

interface IDuplicateShipmentProps {
  type: string;
  reference: string;
}

function DuplicateShipment({ type, reference }: IDuplicateShipmentProps) {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  return (
    <>
      <DuplicateDialog
        isOpen={isDialogOpen}
        close={() => {
          setIsDialogOpen(false);
        }}
        type={type}
        reference={reference}
      />
      <OverlayTrigger
        placement="top"
        delay={{ show: 50, hide: 50 }}
        overlay={
          <Tooltip id="button-tooltip">
            <FormattedMessage id="general.duplicate" defaultMessage="Duplicate" />
          </Tooltip>
        }
        data-testid={testIds.LIST_DUPLICATE_BUTTON}
      >
        <div className="d-inline-block">
          <CopyIcon onClick={() => setIsDialogOpen(true)} height="18" width="18" />
        </div>
      </OverlayTrigger>
    </>
  );
}

DuplicateShipment.propTypes = {
  reference: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
};

export default DuplicateShipment;
